module.exports = __webpack_public_path__ + "img/digital-ads-performance.669d5f67.svg";